import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Button, Grid } from '@mui/material';
import { getServiceCity } from 'redux/actions/UserServiceCity';
import { getDailyCustomer, getRideAnalytic, getRideDetails, getTotalRegistration } from 'redux/actions/UserDashboard';
import { getCabRide, getDashboardFeedback, getOurCar, getRideAccept, getTopDriver, getTopSubVendor, getTopVendor } from 'redux/actions/UserTopSection';
import ChartComponent from 'components/chartComponent/ChartComponent';
import DashboardHeader from 'pages/dashboard/dashHeader/DashboardHeader';
import { adminData, filterdata } from './dashHeader/DashboardData';
import RideDetailsTab from './RideDetailsTab';
import { dateFormate, handlePermissions, hasPermission } from 'utils/utils';
import AddSubVendorDriver from './AddSubVendorDriver';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { setSelectedLocation } from 'redux/actions/LocationDropdown';
import { getSubVendorComplianceExpiryTracker } from 'services/SubVendorComplianceExpiryTrackerService';

function Dashboard() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const role = localStorage.getItem('role')
  const dispatch = useDispatch();
  const [value, setValue] = useState('1');
  const tableData = useSelector((state) => state);
  const totalRegistration = useSelector((state) => state?.userTotalRegistration?.userTotalRegistration?.data) || {}
  const rideAnalytic = useSelector((state) => state?.userRideAnalytic?.userRideAnalytic?.data) || {}
  const dailyCustomer = useSelector((state) => state?.userDailyCustomer?.userDailyCustomer?.data) || {}
  const topVendorData = useSelector((state) => state?.userTopVendor?.userTopVendor?.data);
  const topSubVendorData = useSelector((state) => state?.userTopSubVendor?.userTopSubVendor?.data);
  const topDriverData = useSelector((state) => state?.userTopDriver?.userTopDriver?.data);
  const cabRideData = useSelector((state) => state?.userCabRide?.userCabRide?.data);
  const ourCarData = useSelector((state) => state?.userOurCar?.userOurCar?.data);
  const rideAcceptData = useSelector((state) => state?.userRideAccept?.userRideAccept?.data);
  const locationData = useSelector((state) => state?.userServiceCity?.userServiceCity?.data);
  const dashboardFeedbackData = useSelector((state) => state?.userDashboardFeedback?.userDashboardFeedback);
  const userProfileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);
  const [dateFrom, setDateFrom] = useState(startDate ? startDate : '');
  const [dateTo, setDateTo] = useState(endDate ? endDate : '');
  const [location, setLocation] = useState('');
  const [tableDataDetails, setTableDataDetails] = useState(cabRideData || {})
  const Location = locationData
  const [locValue, setLocValue] = useState(locationData);
  const [locId, setLocId] = useState('');
  const [isLoadingComplianceTracker, setIsLoadingComplianceTracker] = useState(false);
  const [complianceTrackerData, setComplianceTrackerData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const filterData = {
    id: '',
    page: '',
    date: '',
    status: '',
    pageSize: '',
    location: selectedLocation?.id
  }
  let filterDateRange = {
    dateFrom: dateFrom,
    dateTo: dateTo,
    location: selectedLocation?.id
  }
  
  const isLoadingTotalRegistration = useSelector(state => state?.userTotalRegistration.loading)
  const isLoadingRideAnalytic = useSelector(state => state?.userRideAnalytic.loading)
  const isLoadingUserDailyCustomer = useSelector(state => state?.userDailyCustomer.loading)
  const isLoadingCabRide = useSelector((state) => state?.userCabRide?.loading);
  const isLoadingTopSubVendor = useSelector((state) => state?.userTopSubVendor?.loading);
  const isLoadingTopDriver = useSelector((state) => state?.userTopDriver?.loading);

const fetchComplianceTrackerData = async (pageNumber, pageSize, locationId) => {
  setIsLoadingComplianceTracker(true);
  try {
    const res = await getSubVendorComplianceExpiryTracker({
      page: pageNumber,
      pageSize,
      location: locationId || "",
      dateFrom: dateFrom,
      dateTo: dateTo
    });
    setComplianceTrackerData(res?.data || {});
    setTableDataDetails(res?.data || {});
    setTotalItems(res?.data?.totalCount || 0);
  } catch (err) {
    setComplianceTrackerData({ header: [], body: [], totalCount: 0 });
    setTableDataDetails({ header: [], body: [] });
    setTotalItems(0);
  } finally {
    setIsLoadingComplianceTracker(false);
  }
};

const handlePageChange = (page) => {
  setCurrentPage(page);
  fetchComplianceTrackerData(page, itemsPerPage, selectedLocation?.id);
};

const handleItemsPerPageChange = (newItemsPerPage) => {
  setItemsPerPage(newItemsPerPage);
  setCurrentPage(1);
  fetchComplianceTrackerData(1, newItemsPerPage, selectedLocation?.id);
};

const onClickComplianceRow = (row) => {
  navigate(`/compliance/documents`, {
    state: {
      id: row?.ComplianceValueMaster?.id,             
      status: row?.ComplianceValueMaster?.status,
      name: row?.companyName,
      type: "SubVendor",
      submitterId: row?.ComplianceValueMaster?.submitterId,
      fromSubVendorExpiry: true,
    }
  });
};

  useEffect(() => {
    const serviceRegion = localStorage.getItem('serviceRegion');
    const status = localStorage.getItem('status');
    const role = localStorage.getItem('role')
    if (role === 'subVendorCompany') {
      if (status === 'Pending' && serviceRegion === 'true') {
        navigate('/compliance/5?upload=true');
      } else if (serviceRegion !== 'true') {
        navigate('/service')
      }
    }
    dispatch(getServiceCity());
    dispatch(getRideDetails(filterDateRange));
    dispatch(getTotalRegistration(filterDateRange));
    dispatch(getRideAnalytic(filterDateRange));
    dispatch(getDailyCustomer(filterDateRange));
    dispatch(getCabRide(filterData));
    dispatch(getOurCar(filterData));
    dispatch(getTopVendor(filterData));
    dispatch(getTopSubVendor(filterData));
    dispatch(getTopDriver(filterData));
    dispatch(getRideAccept(filterData));
    dispatch(getDashboardFeedback(filterData));

  }, []);

  useEffect(() => {
    if (value === '1') {
      setTableDataDetails(cabRideData);
    } else if (value === '3') {
      setTableDataDetails(topSubVendorData);
    } else if (value === '4') {
      setTableDataDetails(topDriverData);
    } else {
      setTableDataDetails(topVendorData);
    }

  }, [topVendorData, topDriverData, topSubVendorData, cabRideData]);

  useEffect(() => {
    if (userProfileData?.Company?.ServiceCity?.id) {
      setLocValue({
        id: userProfileData?.Company?.ServiceCity?.id,
        name: userProfileData?.Company?.ServiceCity?.name,
      });
    }
  }, [userProfileData?.Company?.ServiceCity?.id]);

  const handleChange = async (newValue) => {
    setValue(newValue);
    if (newValue === '1') {
      dispatch(getCabRide(filterData));
    } else if (newValue === '3') {
      dispatch(getTopSubVendor(filterData));
    } else if (newValue === '4') {
      dispatch(getTopDriver(filterData));
    } else if (newValue === '5') {
      fetchComplianceTrackerData(currentPage, itemsPerPage);
  }
    else {
      dispatch(getTopVendor(filterData));
    }
  }

  const onSelectDateRange = (newValue) => {
    if (newValue === null) {
      setSearchParams({ startDate: 'null', endDate: 'null' })  // Changed this line
      setDateFrom('')
      setDateTo('')
      filterDateRange = {
        ...filterDateRange,
        dateFrom: '',
        dateTo: ''
      }
    } else {
      setSearchParams({ startDate: moment(newValue[0]).format("MM/DD/YYYY"), endDate: moment(newValue[1]).format("MM/DD/YYYY") })
      setDateFrom(moment(newValue[0]).format("MM/DD/YYYY"))
      setDateTo(moment(newValue[1]).format("MM/DD/YYYY"))
      filterDateRange = {
        ...filterDateRange,
        dateFrom: moment(newValue[0]).format("MM/DD/YYYY"),
        dateTo: moment(newValue[1]).format("MM/DD/YYYY")
      }
    }
    dispatch(getRideDetails(filterDateRange));
    dispatch(getTotalRegistration(filterDateRange));
    dispatch(getRideAnalytic(filterDateRange));
    dispatch(getDailyCustomer(filterDateRange));
  }

  const onFilterChange = (val) => {
    setLocation(val)
    filterDateRange = { ...filterDateRange, location: val.toString() }
    dispatch(getRideDetails(filterDateRange));
    dispatch(getTotalRegistration(filterDateRange));
    dispatch(getRideAnalytic(filterDateRange));
    dispatch(getDailyCustomer(filterDateRange));
  }
  const onInputChange = (data) => {
    setLocValue(data);
    setLocId(data?.id);
    filterDateRange = { ...filterDateRange, location: data?.id }
    dispatch(getRideDetails(filterDateRange));
    dispatch(getTotalRegistration(filterDateRange));
    dispatch(getRideAnalytic(filterDateRange));
    dispatch(getDailyCustomer(filterDateRange));
  }

  const onRestFilter = () => {
    setLocation("")
    filterDateRange = { ...filterDateRange, location: "" }
    dispatch(getRideDetails(filterDateRange));
    dispatch(getTotalRegistration(filterDateRange));
    dispatch(getRideAnalytic(filterDateRange));
    dispatch(getDailyCustomer(filterDateRange));
  }

  useEffect(() => {
  if (value === "5" && selectedLocation?.id) {
    fetchComplianceTrackerData(currentPage, itemsPerPage, selectedLocation?.id);
  }
}, [selectedLocation, value]);

  const onRedirectPage = (data) => {
    localStorage.removeItem('tripStatus')
    switch (data.title) {
      case 'Completed Trip':
        navigate(`/rideTrack/1?startDate=${dateFrom}&endDate=${dateTo}&status=completed`, { state: { rideTrackStatus: 'completed', dateFrom, dateTo, fromTab: 'dashboard' } });
        break;
      case 'OnGoing Trip':
        navigate(`/rideTrack/1?startDate=${dateFrom}&endDate=${dateTo}&status=onGoing`, { state: { rideTrackStatus: 'onGoing', dateFrom, dateTo, fromTab: 'dashboard' } });
        break;
      case 'Booked Trip':
        navigate(`/rideTrack/1?startDate=${dateFrom}&endDate=${dateTo}&status=booked`, { state: { rideTrackStatus: 'booked', fromTab: 'dashboard' } });
        break;
      case 'Cancelled Trip':
        navigate(`/rideTrack/1?startDate=${dateFrom}&endDate=${dateTo}&status=cancelled`, { state: { rideTrackStatus: 'cancelled', dateFrom, dateTo, fromTab: 'dashboard' } });
        break;
      case 'Total Drivers':
        return navigate('/driver', { state: { companyType: role } });
      case 'Active Drivers':
        return navigate('/driver', { state: { companyType: role, status: 'Available' } });
      case 'Active Sub-Vendors':
        return navigate('/subvendor', { state: { companyType: role, subVendorStatus: 'Active' } });
      case 'Driver':
        return navigate('/driver', { state: { companyType: role } });
      case 'Trip':
        navigate(`/rideTrack/1?startDate=${dateFrom}&endDate=${dateTo}`, { state: { rideTrackStatus: '', dateFrom, dateTo, fromTab: 'dashboard' } });
        break;
      default:
        return
    }
  }

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const dashBoardRoleEnum = roleAndPermissionEnum.dashboard;
  const accessForall = handlePermissions(
    roleAndPermissions,
    dashBoardRoleEnum.moduleKey,
    {
      defaultAllAccess: dashBoardRoleEnum.all,
    }
  );

  return (
    <div>
      <Grid className="marginBottom25">
        <DashboardHeader
          dashboardData={adminData(tableData?.userRideDetails?.userRideDetails?.data)}
          onSelectDateRange={onSelectDateRange}
          filterdata={filterdata}
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          role={role}
          onInputChange={onInputChange}
          locValue={locValue}
          Location={Location}
          tabName={'dashboard'}
          onRedirectPage={onRedirectPage}
          dateFrom={dateFrom}
          dateTo={dateTo}
          userProfileData={userProfileData}
          selectCity={true}
          selectedLocation={selectedLocation}
        />
      </Grid>
      <Grid className="marginBottom25">
        <ChartComponent
          tableData={tableData}
          role={role}
          totalRegistration={totalRegistration}
          rideAnalytic={rideAnalytic}
          dailyCustomer={dailyCustomer}
          isLoadingRegistration={isLoadingTotalRegistration}
          isLoadingAnalytic={isLoadingRideAnalytic}
          isLoadingCustomer={isLoadingUserDailyCustomer}
        />
      </Grid>
      <Grid className="marginBottom25">
        <RideDetailsTab 
        tableDataDetails={tableDataDetails} 
        ourCarData={ourCarData} 
        rideAcceptData={rideAcceptData} 
        dashboardFeedbackData={dashboardFeedbackData} 
        value={value} 
        handleChange={handleChange} 
        isLoadingCabRide={isLoadingCabRide} 
        isLoadingTopSubVendor={isLoadingTopSubVendor} 
        isLoadingTopDriver={isLoadingTopDriver} 
        isLoadingComplianceTracker={isLoadingComplianceTracker}
        complianceTrackerData={complianceTrackerData}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onItemsPerPageChange={handleItemsPerPageChange}
        onClickComplianceRow={onClickComplianceRow}
        />
      </Grid>
    </div>
  );
}

export default Dashboard;
